import { useContext } from 'react';
import { ContactsContext } from '../context/ContactsContextProvider/ContactsContextProvider';

// Currently this hook only looks at the first contact in the list. So this won't work perfectly for Contracts
const useContactIsChanging = ( previousContactId?: string ) => {
	// The current client side contact information
	const contactsContext = useContext( ContactsContext );
	// invoiceEditContext won't have the contact when this is clicked if the contact has changed since the last save
	const currentContactId = contactsContext?.contacts?.[ 0 ]?.id;
	const previousContactDiffersFromCurrent = previousContactId
		? previousContactId !== currentContactId
		: false;
	return previousContactDiffersFromCurrent;
};

export default useContactIsChanging;
